import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Util } from '../../utils/util';
import { DominioService } from '../../services/dominio.service';
import { MensagemService } from '../../pages/gestor/shared/services/mensagem.service';
import { Aldeia, CNES_TIPO, CboProfissional, DistritoSanitario, Profissional, RegiaoAdministrativa, RegiaoSaude } from '../../models/dominios';
import { ResponseUtil } from '../../utils/response.util';
import { Guid } from 'guid-typescript';

@Component({
    selector: 'app-selecao-filtro',
    templateUrl: './selecao-filtro.page.html',
    styleUrls: ['./selecao-filtro.page.scss']
})
export class SelecaoFiltroPage implements OnInit {

    @Input() lista: Array<any>;
    @Input() nomeAtributoDescricao: string;
    @Input() nomeAtributoCodigo: string;
    @Input() titulo: string;
    @Input() selecaoMultipla = false;
    @Input() showPesquisa = false;
    @Input() autoComplete = false;
    @Input() carregarLista = false;
    @Input() clazz: new () => any;
    @Input() codigo: any;
    @Input() params: any;
    @Input() addCodigoToFilter: boolean = true;
    @Input() dismissOnEmptyResult: boolean = true;
    @Input() searchOnEmptyFilter: boolean = true;
    @Input() useDebounce: boolean = false;
    @Input() showMsgOnEmptyresult: boolean = false;
    @Input() enableUncheck: boolean = false;
    @Input() placeholder: string = 'Pesquisar';
    @Input() minFilterLength: number = 1;
    @Input() selectAll: boolean = false;
    @Input() cacheMultiSelect: any[] = [];
    @Input() attrForPreviousSelected;
    @Input() ignoreCodigo;

    public filtro = '';
    public itemMarcado: string | number;

    listaCompleta = [];

    flagListaCompleta = false;
    uniqueGuid;

    sent = false;
    timer;

    selecionarTudo: any = {};

    selecionadosCache = [];

    constructor(
        private modalController: ModalController,
        private dominioService: DominioService,
        private mensagemService: MensagemService
    ) {
    }


    async ngOnInit() {
        this.selecionadosCache = [];
        if (this.lista && this.lista.length > 0) {
            this.flagListaCompleta = true;
            this.lista.forEach(item => {
                item[this.nomeAtributoDescricao] = item[this.nomeAtributoDescricao];
            });
            if (this.cacheMultiSelect.length  && this.selecaoMultipla && this.attrForPreviousSelected && !this.carregarLista) {
                this.selecionadosCache = this.cacheMultiSelect;
                this.lista = this.lista.map((val) => ({ ...val, marcado: this.cacheMultiSelect.find((pr) => pr[this.attrForPreviousSelected] === val[this.attrForPreviousSelected]) }))
            }
            this.listaCompleta = this.lista;
        }
        if (this.carregarLista) {
            if (this.useDebounce) {
                await this.debounce(async () => await this.popularLista());
            }
            if (this.searchOnEmptyFilter) {
                await this.popularLista();
            }
        }
        this.uniqueGuid = Guid.create().toString();
        if (this.lista && this.lista.length === 0 && this.showMsgOnEmptyresult && !this.carregarLista) {
            await this.mensagemService.showToast('Não existe resultado para o filtro informado.');
        }

        // console.log(this.selecionadosCache, this.cache)
    }

    private getProperFilter(item) {
        if (this.addCodigoToFilter) {
            return `${(item[this.nomeAtributoCodigo]) + ''.toLowerCase()} - ${item[this.nomeAtributoDescricao].toLowerCase()}`
        }

        return item[this.nomeAtributoDescricao].toLowerCase();
    }

    debounce(func) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, 1000);
        };
    }

    async popularListaAsync() {
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => { await this.popularLista() }, 1000);
    }

    private minimalLengthFilter() {
        return Math.max(1, this.minFilterLength);
    }

    async popularLista() {
        if (this.flagListaCompleta && (this.filtro.length === 0 || this.filtro.length > this.minimalLengthFilter())) {
            if (this.filtro.length > 0 && this.lista) {
                const newLista = this.listaCompleta;
                this.lista = newLista.filter(item => Util.indexOfSemAcentos(
                    this.getProperFilter(item), this.filtro.toLowerCase())
                );
                if (this.lista.length === 0 && this.showMsgOnEmptyresult) {
                    await this.mensagemService.showToast('Não existe resultado para o filtro informado.');
                }
            } else {
                this.lista = this.listaCompleta;
            }
        } else if ((this.filtro.length === 0 || this.filtro.length > this.minimalLengthFilter())) {
            if (!this.searchOnEmptyFilter && this.filtro.length === 0) {
                return;
            }
            if (this.sent) {
                return;
            }
            this.sent = true;
            await this.mensagemService.presentLoading();
            this.lista = [];
            const dominioServiceResponse = this.dominioService.get(this.clazz, this.filtro, this.codigo, this.params);
            if (!dominioServiceResponse) {
                this.lista = [];
                await this.mensagemService.dismissLoading();
                return;
            }
            dominioServiceResponse.then(async (resultado) => {
                resultado = ResponseUtil.tratar(resultado);
                if (!resultado || !resultado.length) {
                    await this.mensagemService.showToast('Não existe resultado para o filtro informado.');
                    if (this.dismissOnEmptyResult) {
                        this.modalController.dismiss();
                    }
                    return;
                }
                if (this.clazz === CboProfissional) {
                    this.lista = resultado.map((item) => {
                        return new CboProfissional(item);
                    });
                } else if (this.clazz === CNES_TIPO) {
                    this.lista = resultado.map((r) => ({ ...r, descricao: `${r.nomeFantasiaEstabelecimento} - ${r.municipio.id} - ${r.municipio.nome}`, codigo: r.cnesEstabelecimento }));
                    this.lista = this.lista.sort((r1, r2) => ('' + r1.codigo).localeCompare(('' + r2.codigo)));
                } else {
                    this.lista = resultado;
                }

                if (this.clazz === Profissional) {
                    this.lista = this.lista.map((p) => ({
                        ...p,
                        cpf: (p.profissionalSUS ? p.profissionalSUS.cpf : '')
                    }))
                }

                if (this.clazz === RegiaoSaude || this.clazz === Aldeia) {
                    this.lista = resultado.sort((r1, r2) => ('' + r1.nome).localeCompare(('' + r2.nome)));
                }

                if (this.clazz === RegiaoAdministrativa) {
                    this.lista = resultado.filter((r) => r.nome !== 'BRASILIA' && !r.nome.includes('MUNICÍPIO IGNORADO'));
                    if (!this.lista.length) {
                        await this.mensagemService.showToast('Não existe resultado para o filtro informado.');
                        if (this.dismissOnEmptyResult) {
                            this.modalController.dismiss();
                        }
                        return;
                    }
                }

                if(this.clazz === DistritoSanitario) {
                    console.log(this.lista, 'ejkbriwe rkjnw dkwjeb jhwvegjz')
                }

                // validação de item marcado - multiselect

                if (this.cacheMultiSelect.length && this.attrForPreviousSelected && this.selecaoMultipla) {
                    this.selecionadosCache = this.cacheMultiSelect;
                    this.lista = this.lista.map((val) => ({ ...val, marcado: this.cacheMultiSelect.find((pr) => pr[this.attrForPreviousSelected] === val[this.attrForPreviousSelected]) }))
                }

            }).catch((erro) => {
                this.lista = [];
                this.mensagemService.showToast(erro);
            }).finally(async () => {
                this.sent = false;
                await this.mensagemService.dismissLoading();
            });
        }
    }

    async confirmar() {
        if (this.selecaoMultipla) {
            if (!this.lista) {
                this.lista = [];
            }
            // const itensSelecionados = this.lista.filter((item: any) => {
            //     return item.marcado;
            // });
            const itensSelecionados = this.selecionadosCache;
            await this.modalController.dismiss(itensSelecionados);
        } else {
            if (!this.itemMarcado) {
                await this.mensagemService.showToast('Selecione um item.');
                return;
            }
            if (this.itemMarcado === this.uniqueGuid) {
                await this.modalController.dismiss({ empty: true });
                return;
            }
            await this.modalController.dismiss(this.lista.find((item: any) => {
                return item[this.nomeAtributoCodigo].toString() === this.itemMarcado.toString();
            }));
        }
    }

    async fechar() {
        await this.modalController.dismiss();
    }

    teste(q) {
        console.log(q)
    }

    selecionarTodos() {
        if(!this.selecionarTudo.ignore || this.selecionarTudo.checked) {
            this.lista = this.lista.map((d) => ({ ...d, marcado: this.selecionarTudo.checked }));
            this.selecionarTudo.ignore = false;
        }
    }

    limparSelecionarTudo() {
        if(this.selecionarTudo.checked) {
            this.selecionarTudo.ignore = true;
            this.selecionarTudo.checked = false;
        }
    }

    selecionarUmMultipleSelect(dado) {
        if(dado.marcado) {
            this.selecionadosCache.push(dado);
        } else {
            this.selecionadosCache = this.selecionadosCache.filter((data) => data[this.attrForPreviousSelected] !== dado[this.attrForPreviousSelected]);
        }
        this.limparSelecionarTudo();
    }

}
